import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertController, ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';
import { HONAPOK, fmt, fmtMax, hibaSzoveg, huDatum } from '../utnyilvantartas/gj-nyomtatas';

/*  GÉPJÁRMŰ – HAVI KM-ELSZÁMOLÁS járművenként: km jelleg szerint, normás üzemanyag (korrekciókkal, a NAV havi
 *  árán), magánautónál a térítés (normás üzemanyag + általános normaköltség, Szja tv. 3. melléklet II. 6.) és a
 *  munkába járás (39/2010. Korm. r.), céges autónál a tankolás és a normás fogyasztás különbsége
 *  (megtakarítás / túlfogyasztás), óraállás-egyezés és a hiányzó adatok.
 *  ÁTADÁS A BÉRBE: a lezárt kiküldetési rendelvények (155-ös jogcím) és a munkába járás (150/151) a sofőr
 *  Bér-dolgozójának hónapjába – újra-átadáskor a korábbi cserélődik, visszavonható, amíg a Bérben a hónap
 *  nincs véglegesítve. Backend: backend/gepjarmu-ut.js (/elszamolas, /ber-atadas…). */
@Component({
  selector: 'app-gj-elszamolas',
  templateUrl: './elszamolas.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjElszamolasComponent implements OnInit, OnDestroy {
  readonly honapok = HONAPOK;
  ho = new Date().getMonth() + 1;
  adat: any = null;
  atad: any = null;
  atadAblak: any = null;
  dolgozik = false;
  private sub?: Subscription;
  private kulcs = '';
  fmt = fmt; fmtMax = fmtMax; huDatum = huDatum;

  constructor(public gj: GepjarmuService, private toast: ToastController, private alert: AlertController) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ev() { return this.gj.aktiv.ev; }
  get ir() { return this.gj.ir; }

  async ngOnInit() {
    await this.gj.init();
    this.sub = this.gj.aktiv$.subscribe((a) => { const k = `${a.ugyfelId}|${a.ev}`; if (k !== this.kulcs) { this.kulcs = k; this.frissit(); } });
  }
  ngOnDestroy() { this.sub?.unsubscribe(); }

  async frissit() {
    if (!this.u) { this.adat = null; this.atad = null; return; }
    try {
      const [adat, atad] = await Promise.all([
        this.gj.get(`ut:/elszamolas/${this.u}?ev=${this.ev}&ho=${this.ho}`),
        this.gj.get(`ut:/ber-atadasok/${this.u}?ev=${this.ev}&ho=${this.ho}`),
      ]);
      this.adat = adat; this.atad = atad;
    } catch (e: any) { this.adat = null; this.hiba(hibaSzoveg(e, 'Nem sikerült az elszámolás.')); }
  }
  hoLep(d: number) {
    let ho = this.ho + d, ev = this.ev;
    if (ho < 1) { ho = 12; ev--; } else if (ho > 12) { ho = 1; ev++; }
    this.ho = ho;
    if (ev !== this.ev) { this.gj.setAktiv({ ev }); return; }
    this.frissit();
  }
  get latszik(): any[] { return (this.adat?.jarmuvek || []).filter((j: any) => j.utak_db || j.tankolt?.db); }
  get uresek(): any[] { return (this.adat?.jarmuvek || []).filter((j: any) => !j.utak_db && !j.tankolt?.db); }
  get uresRendszamok(): string { return this.uresek.map((j) => j.jarmu.rendszam).join(', '); }
  get vanAtadhato(): boolean { return !!(this.atad?.atadhato?.rendelvenyek?.length || this.atad?.atadhato?.munkaba?.length); }
  get elo(): any[] { return (this.atad?.atadasok || []).filter((a: any) => !a.visszavonva); }
  get visszavontak(): any[] { return (this.atad?.atadasok || []).filter((a: any) => a.visszavonva); }
  atadva(fajta: string, forrasId: string): any { return this.elo.find((a) => a.fajta === fajta && a.forras_id === forrasId); }

  /* ── átadás a Bérbe ── */
  atadNyit() {
    const a = this.atad?.atadhato || { rendelvenyek: [], munkaba: [] };
    this.atadAblak = {
      rendelvenyek: Object.fromEntries(a.rendelvenyek.filter((r: any) => r.nyomtatva && r.fizetendo_ft > 0).map((r: any) => [r.id, true])),
      soforok: Object.fromEntries(a.munkaba.filter((m: any) => m.sofor_id && m.ber_kotve).map((m: any) => [m.sofor_id, true])),
    };
  }
  get atadKijelolt(): { r: string[]; s: string[] } {
    const w = this.atadAblak || { rendelvenyek: {}, soforok: {} };
    return { r: Object.keys(w.rendelvenyek).filter((k) => w.rendelvenyek[k]), s: Object.keys(w.soforok).filter((k) => w.soforok[k]) };
  }
  async atadas() {
    const { r, s } = this.atadKijelolt;
    if (!r.length && !s.length) return;
    this.dolgozik = true;
    try {
      const v: any = await this.gj.post(`ut:/ber-atadas/${this.u}`, { ev: this.ev, ho: this.ho, rendelvenyek: r.length > 0, rendelveny_idk: r, munkaba: s.length > 0, sofor_idk: s });
      this.atadAblak = null;
      this.ok(`${v.atadva.length} tétel átadva a Bérbe (${fmt(v.atadva.reduce((x: number, a: any) => x + Number(a.osszeg || 0), 0))} Ft).`);
      if (v.figyelmeztetes?.length) this.figy(v.figyelmeztetes.join('\n'));
      await this.frissit();
    } catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült az átadás.')); }
    finally { this.dolgozik = false; }
  }
  async visszavon(a: any) {
    const al = await this.alert.create({ header: 'Átadás visszavonása', message: `A Bérből törlődik a(z) ${a.fajta === 'kikuldetes' ? (a.sorszam || 'rendelvény') : 'munkába járás'} tétele (${fmt(a.osszeg)} Ft, ${a.reszletek?.alkalmazott_nev || ''}).`,
      buttons: [{ text: 'Mégsem', role: 'cancel' }, { text: 'Visszavonás', role: 'destructive', handler: () => this.visszavonVeg(a) }] });
    await al.present();
  }
  private async visszavonVeg(a: any) {
    try { await this.gj.del(`ut:/ber-atadas/${a.id}`); this.ok('Az átadás visszavonva.'); await this.frissit(); }
    catch (e: any) { this.hiba(hibaSzoveg(e, 'Nem sikerült visszavonni.')); }
  }
  fajtaNev(f: string) { return f === 'kikuldetes' ? 'Kiküldetési rendelvény' : f === 'munkaba_jaras' ? 'Munkába járás' : f; }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 3000, color: 'success' })).present(); }
  private async figy(m: string) { (await this.toast.create({ message: m, duration: 6500, color: 'warning' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
